import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=65039d64&"
import script from "./BusinessDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports